// Create a single TextEncoder instance to reuse across all calls
const encoder = new TextEncoder()

/**
 * Calculate the UTF-8 byte length of a string.
 *
 * This is useful for validating character limits for APIs that count bytes
 * rather than JavaScript string length (which counts UTF-16 code units).
 *
 * For example:
 * - "hello" has a JS length of 5 and UTF-8 byte length of 5
 * - "👢" (boot emoji) has a JS length of 2 but UTF-8 byte length of 4
 * - "—" (em dash) has a JS length of 1 and UTF-8 byte length of 3
 *
 * @param str - The string to measure
 * @returns The number of bytes the string would take in UTF-8 encoding
 */
const getUtf8ByteLength = (str: string | null | undefined): number => {
  if (!str) {
    return 0
  }

  // TextEncoder always encodes to UTF-8
  return encoder.encode(str).length
}

export { getUtf8ByteLength }
